import React from "react";
import {Button, Col, Row} from "react-bootstrap";
import Modal from "react-responsive-modal";
export default function RebootAlertModal(props) {
    return (
        <Modal open={props.show} onClose={props.onCloseClicked}>
            <h4 style={{width: "1000px"}}> Are you sure you want to restart the switch ?</h4>
            <Row>
                    <div style={{marginTop: 4,marginLeft:15}}>
                        Restarting a switch may take some time, click 'Proceed' to continue.
                    </div>
            </Row>
            <Row>
                <Col sm={12}>
                <Button variant="primary" style={{margin: 20}}
                        onClick={props.onRestartSwitch}>Proceed</Button>
                </Col>
            </Row>
        </Modal>
    )  
}
